// Redux service request action types

export const FETCH_SERVICE_REQUESTS_FAILURE = 'FETCH_SERVICE_REQUESTS_FAILURE';

export const POST_SERVICE_REQUEST = 'POST_SERVICE_REQUEST';
export const POST_SERVICE_REQUEST_SUCCESS = 'POST_SERVICE_REQUEST_SUCCESS';
export const POST_SERVICE_REQUEST_FAILURE = 'POST_SERVICE_REQUEST_FAILURE';
